module.exports = __webpack_public_path__ + "static/media/icon-transfer-black.70ebc1e7.png";